import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSText } from '@egds/react-core/text';
export const PlaybackSubHeading = ({
  destinationMessage,
  dateRange,
  guestCountTitle
}) => React.createElement(EGDSText, {
  align: "left",
  overflow: "truncate"
}, React.createElement(EGDSText, {
  dataTestId: "content-location-title",
  overflow: "truncate",
  size: 400,
  weight: "medium"
}, destinationMessage), React.createElement(React.Fragment, null, React.createElement(EGDSText, {
  dataTestId: "playback-date-range",
  inline: true,
  size: 200,
  weight: "medium"
}, dateRange), guestCountTitle && React.createElement(EGDSSpacing, {
  padding: {
    inline: 'two'
  }
}, React.createElement(EGDSText, {
  dataTestId: "playback-guest-count",
  inline: true,
  size: 200,
  weight: "medium",
  "aria-label": `, ${guestCountTitle}`
}, guestCountTitle))));